export default "__VITE_ASSET__CUmL4fd8__"